'use client'

import {ReactNode} from 'react'
import {useInteractionDetected} from './interaction-provider-client'
import {useIsHomepage} from './use-is-home-page'

interface Props {
  children: ReactNode
}

export function LoadOnUserInteractionClient({children}: Props) {
  const hasInteracted = useInteractionDetected()
  return hasInteracted ? children : null
}
